import { appFetch, AppFetchResponse } from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getShopSegments = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop-segments?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}